const RelationalModel = require('../extensions/relational-model.js');
const RelationalCollection = require('../extensions/relational-collection.js');
const parameters = require('./parameters.js');

const Coach = RelationalModel.extend({
  mutators: {
    name() {
      const name = this._has('name')
        ? `${this._get('name')
            .charAt(0)
            .toUpperCase()}.`
        : '';
      const surname = this._has('surname') ? this._get('surname') : '';
      return `${surname} ${name}`;
    }
  }
});

const CoachCollection = RelationalCollection.extend({
  model: Coach,
  url() {
    return `${parameters.get('api_base_url')}/${parameters.get('client_token')}/coaches`;
  }
});

module.exports = new CoachCollection();



// WEBPACK FOOTER //
// ./src/data/coaches.js